module.exports = __webpack_public_path__ + "img/part9-1.33273311.png";